import { render } from "./create-card.template.html?vue&type=template&id=f7a9d884&scoped=true"
import script from "./CreateCard.vue?vue&type=script&lang=ts"
export * from "./CreateCard.vue?vue&type=script&lang=ts"

import "./CreateCard.vue?vue&type=style&index=0&id=f7a9d884&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f7a9d884"

export default script